document.documentElement.className=document.documentElement.className.replace('no-js','js');
// Mobile nav (hamburger) toggle
(function(){
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    var header=document.getElementById('SiteHeader');
    if(!header) return;
    var btn=header.querySelector('.nav-toggle');
    var nav=header.querySelector('#PrimaryNav');
    if(!btn||!nav) return;
    function setOpen(open){
      header.classList.toggle('nav-open',open);
      btn.setAttribute('aria-expanded',open?'true':'false');
      btn.setAttribute('aria-label',open?'Close menu':'Open menu');
    }
    btn.addEventListener('click',function(){ setOpen(!header.classList.contains('nav-open')); });
    nav.addEventListener('click',function(e){ if(e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') setOpen(false); });
    window.addEventListener('resize',function(){ if(window.innerWidth>900) setOpen(false); });
  });
})();

// Nav dropdown submenus: caret buttons toggle .open (touch + keyboard);
// desktop hover is pure CSS. Escape / outside click closes.
(function(){
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    var header=document.getElementById('SiteHeader');
    if(!header) return;
    function closeAll(except){
      header.querySelectorAll('.nav-item.open').forEach(function(item){
        if(item===except) return;
        item.classList.remove('open');
        var c=item.querySelector('.nav-caret');
        if(c) c.setAttribute('aria-expanded','false');
      });
    }
    header.querySelectorAll('.nav-caret').forEach(function(caret){
      caret.addEventListener('click',function(e){
        e.stopPropagation();
        var item=caret.closest('.nav-item');
        var open=!item.classList.contains('open');
        closeAll(item);
        item.classList.toggle('open',open);
        caret.setAttribute('aria-expanded',open?'true':'false');
      });
    });
    document.addEventListener('click',function(e){ if(!e.target.closest('.nav-item')) closeAll(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
  });
})();

// Reveal-on-scroll for homepage sections (.reveal -> .seen). Graceful: if
// IntersectionObserver is unavailable, reveal everything immediately.
(function(){
  function run(){
    var els=document.querySelectorAll('.reveal');
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){el.classList.add('seen');}); return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('seen'); io.unobserve(e.target); } });
    },{threshold:.12});
    els.forEach(function(el){io.observe(el);});
  }
  if(document.readyState!='loading'){run();} else {document.addEventListener('DOMContentLoaded',run);}
})();

/* Maps links: Apple platforms get Apple Maps, everyone else keeps the Google
   URL already in the href. Done as a rewrite rather than UA-branching in Liquid
   because Shopify caches pages across visitors — the markup has to be identical
   for everyone, so the platform choice can only happen in the browser. If this
   script never runs the Google link still works. */
(function(){
  var ua = navigator.userAgent || '';
  var isApple = /iPad|iPhone|iPod/.test(ua) ||
                /Macintosh/.test(ua) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isApple) return;
  var run = function(){
    var links = document.querySelectorAll('a[data-maps-apple]');
    for (var i = 0; i < links.length; i++) {
      links[i].href = links[i].getAttribute('data-maps-apple');
    }
  };
  if (document.readyState != 'loading') { run(); }
  else { document.addEventListener('DOMContentLoaded', run); }
})();
